import { Cellstyle, HotCell } from "~app/common/components/hot-doc/hotdoc/cell";
import { ProduktionsomradeKundorderradAggregat } from "../models/jlp-produktionsomrade-model";

export class KundorderradCell extends HotCell {

    constructor(private readonly markupBuilder: () => string) {
        // eslint-disable-next-line no-bitwise
        super(Cellstyle.Readonly | Cellstyle.White | Cellstyle.NoRightBorder, { rowSpan: 2 });
    }

    static create(source: ProduktionsomradeKundorderradAggregat): KundorderradCell {
        const buildMarkup = (): string => {
            const link = `<a style="display:block;" href = "/core/kundorder/${source.kundorderId}">
                <span data-bs-toggle="tooltip" title="${source.kundNamn}">${source.kundNamn.substring(0, 20).replace(/(\r\n|\n|\r)/gm, "")}
                </span></a>`;
            const mottagningsplats = `<span title="${source.mottagningsplats.namn}">${source.mottagningsplats.namn.substring(0, 20)}</span>`;
            return `<div>${link}</div><div>${mottagningsplats}</div><div>${source.handelssortiment.namn} ${source.mattslag}</div>`;
        };

        return new KundorderradCell(buildMarkup);
    }

    validate(value: any): boolean {
        return false;
    }

    override onDelete(): void { }

    protected genHtml(): string {
        return this.markupBuilder();
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        super.applyStyle(td, cellProperties);

        td.style.verticalAlign = "middle";
        td.style.textAlign = "left";
    }
}
